import React from 'react';

import { smallRadius } from '~/src/dash/utils/material-dashboard-react';

export function BlueBackground(props: any) {
  return (
    <div
      style={{
        background: 'aliceblue',
        borderRadius: smallRadius,
        opacity: '1',
        paddingLeft: '10px',
        paddingRight: '10px',
        width: 'inherit',
      }}
    >
      {props.children}
    </div>
  );
}
